<!--基础组件：Loading
    @dengli
    @date 2018年11月2日
    props
        - isShowProgress 设置进度显示|隐藏状态
        - progress 进度
        - total 总任务数
    调用示例:
        <loading :isLoading="isLoading"/>
-->
<template>
  <div class="lanhu-loading" v-show="isLoading">
    <img class="loading-img" src="../../assets/imgs/loading.gif">
    <div class="loading-progress" v-show="isShowProgress">{{progress}}/{{total}}</div>
  </div>
</template>
<style lang="scss" scoped>
.lanhu-loading {
    position: fixed;
    z-index: 99;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    .loading-img,
    .loading-progress {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate3d(-50%, -50%, 0);
    }
    .loading-img {
        width: 2rem;
        height: 2rem;
    }
    .loading-progress {
        font-size: 0.6rem;
        font-weight: 400;
        color: rgba(36, 56, 89, 1);
        margin-top: 1.55rem;
        line-height: 0.83rem;
    }
}
</style>
<script>
export default {
    name: "Loading",
    props: {
        isShowProgress: {
            type: Boolean,
            default: false
        },
        progress: {
            type: Number,
            default: 0
        },
        total: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            isLoading: false
        }
    },
    mounted() {
        this.$root.eventBus.$on("hideLoading", this.hideLoading)
        this.$root.eventBus.$on("showLoading", this.showLoading)
    },
    methods: {
        showLoading() {
            this.isLoading = true
            setTimeout(() => {
                if (this.isLoading == true) {
                    this.hideLoading()
                }
            }, 6000)
        },
        hideLoading() {
            this.isLoading = false
        }
    }
}
</script>


